/**
 * @file Automatically generated by barrelsby.
 */

export * from './employee-layout.component';
